import { tokenStorage } from "@/lib/storage/token";

import { apiPublicClient } from "./public-client";

let isRefreshing = false;
let refreshPromise: Promise<boolean> | null = null;

async function doRefresh(): Promise<boolean> {
  const rt = tokenStorage.getRefreshToken();
  if (!rt) return false;

  try {
    const { data, response } = await apiPublicClient.POST("/auth/refresh", {
      body: { refresh_token: rt },
    });
    if (!response.ok || !data) {
      tokenStorage.clear();
      return false;
    }
    tokenStorage.set(data.access_token, data.refresh_token);
    return true;
  } catch {
    tokenStorage.clear();
    return false;
  }
}

export async function refreshIfNeeded(): Promise<boolean> {
  if (isRefreshing && refreshPromise) return refreshPromise;
  isRefreshing = true;
  refreshPromise = doRefresh().finally(() => {
    isRefreshing = false;
    refreshPromise = null;
  });
  return refreshPromise;
}
